import { createComponentOverrides } from '../theme/create-component-overrides';
import { iconButtonClasses } from '@mui/material/IconButton';
export var createMuiIconButtonOverrides = createComponentOverrides(function (_a) {
    var _b;
    var typography = _a.typography, tokens = _a.tokens;
    return {
        defaultProps: {},
        styleOverrides: {
            root: (_b = {},
                _b["&.".concat(iconButtonClasses.disabled, ", &:disabled")] = {
                    color: tokens.color_fg_on_button_disabled,
                    backgroundColor: tokens.color_bg_button_disabled,
                    borderColor: tokens.color_border_disabled,
                },
                _b),
        },
        variants: [
            {
                props: { size: 'medium' },
                style: {
                    fontSize: typography.pxToRem(16),
                    height: typography.pxToRem(34),
                    width: typography.pxToRem(34),
                },
            },
            {
                props: { size: 'small' },
                style: {
                    fontSize: typography.pxToRem(16),
                    height: typography.pxToRem(30),
                    width: typography.pxToRem(30),
                },
            },
            {
                props: { size: 'large' },
                style: {
                    fontSize: typography.pxToRem(16),
                    height: typography.pxToRem(40),
                    width: typography.pxToRem(40),
                },
            },
            {
                props: { color: 'primary' },
                style: {
                    color: tokens.color_fg_link_primary,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_link_primary_hover,
                        backgroundColor: tokens.color_bg_link_primary_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_link_primary_pressed,
                        backgroundColor: tokens.color_bg_link_primary_pressed,
                    },
                },
            },
            {
                props: { color: 'inherit' },
                style: {
                    '&:hover,&.Mui-hover': {
                        backgroundColor: "rgba(0,0,0, 0.04)",
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: "rgba(0,0,0, 0.1)",
                    },
                },
            },
            {
                props: { color: 'danger' },
                style: {
                    color: tokens.color_fg_link_danger,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_link_danger_hover,
                        backgroundColor: tokens.color_bg_link_danger_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_link_danger_pressed,
                        backgroundColor: tokens.color_bg_link_danger_pressed,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'primary' },
                style: {
                    backgroundColor: tokens.color_bg_button_primary,
                    color: tokens.color_fg_on_button_primary,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_on_button_primary,
                        backgroundColor: tokens.color_bg_button_primary_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_on_button_primary,
                        backgroundColor: tokens.color_bg_button_primary_pressed,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'danger' },
                style: {
                    backgroundColor: tokens.color_bg_button_danger,
                    color: tokens.color_fg_on_button_danger,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_on_button_danger,
                        backgroundColor: tokens.color_bg_button_danger_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_on_button_danger,
                        backgroundColor: tokens.color_bg_button_danger_pressed,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'default' },
                style: {
                    color: tokens.color_fg_on_button,
                    backgroundColor: tokens.color_bg_layer_alternate_bold,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_layer_bold,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_layer_bold,
                    },
                },
            },
            {
                props: { variant: 'outlined' },
                style: {
                    borderStyle: 'solid',
                    borderWidth: 1,
                },
            },
            {
                props: { variant: 'outlined', color: 'default' },
                style: {
                    backgroundColor: tokens.color_bg_button,
                    borderColor: tokens.color_border_button,
                    color: tokens.color_fg_on_button,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_button_hover,
                        borderColor: tokens.color_border_button,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_button_pressed,
                        borderColor: tokens.color_border_button,
                    },
                },
            },
            {
                props: { variant: 'outlined', color: 'primary' },
                style: {
                    color: tokens.color_fg_link_primary,
                    // This will be removed in the new brand. Using fg for border to match since new brand doesn't have this token.
                    borderColor: tokens.color_fg_link_primary,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_link_primary_hover,
                        borderColor: tokens.color_fg_link_primary,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_link_primary_pressed,
                        borderColor: tokens.color_fg_link_primary,
                    },
                },
            },
            {
                props: { variant: 'link', color: 'default' },
                style: {
                    backgroundColor: 'transparent',
                    color: tokens.color_fg_link,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_link_hover,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_link_pressed,
                    },
                },
            },
        ],
    };
});
